import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HasAnyRoleDirective } from '@core/directives/has-any-role.directive';
interface Submenus {
  showSubmenuOne: boolean;
  showSubmenuTwo: boolean;
  showSubmenuThree: boolean;
  showSubmenuFour: boolean;
}
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  imports: [CommonModule, RouterLink, RouterLinkActive, HasAnyRoleDirective],
  standalone: true,
})
export class SideBarComponent {
  submenus: Submenus = {
    showSubmenuOne: true,
    showSubmenuTwo: false,
    showSubmenuThree: false,
    showSubmenuFour: false,
  };

  toggleSubmenu(menu: keyof Submenus) {
    this.submenus[menu] = !this.submenus[menu];
  }
}
